import clamp from 'lodash/clamp';

import { dashesOrNum } from './number';

export const formatPercentage = (
  value: number | string | null | undefined,
  { roundBy }: { roundBy?: number } = {}
): string =>
  dashesOrNum({
    value,
    roundBy: roundBy ?? 2,
    decimals: 2,
    mapNumber: (num) => `${num}%`,
    mapDashes: (it) => `${it}%`,
  }) as string;

export const normalizePercentage = (num: number): number => clamp(num, 0, 100);
